import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

/**Страница с настройками паролей */
const SettingsPassword = () => import("../../pages/settings-password/settings-password.vue");

/**Страница с настройкой rdp */
const RdpPage = () => import("rdp_section/Rdp");
import RdpRoute from "rdp_section/RdpRoutes";

/**Маршруты проекта настроек */
const generalSettingsRoutes: Array<RouteRecordRaw> = [
  {
    path: "password",
    name: "password",
    component: SettingsPassword,
    meta: {
      name: "Настройки паролей",
    },
  },
  RdpRoute,
];

export default generalSettingsRoutes;
